import { render, staticRenderFns } from "./ProductsViewContent.vue?vue&type=template&id=4159fcf9&scoped=true&"
import script from "./ProductsViewContent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProductsViewContent.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ProductsViewContent.vue?vue&type=style&index=0&id=4159fcf9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4159fcf9",
  null
  
)

export default component.exports